import { useLocation, Outlet } from 'react-router-dom';
import Header from '../common/Header';
import AuthMarketingPanel from '../auth/AuthMarketingPanel';
import AuthFooter from '../auth/AuthFooter';

const AuthLayout = () => {
  const location = useLocation();
  const variant = location.pathname === '/sign-up' ? 'signup' : 'signin';

  return (
    <div className="min-h-screen bg-ui-background-primary text-ui-text-primary flex flex-col">
      <Header type="homepage" />
      <main className="flex-1 flex flex-col lg:flex-row lg:items-center px-4 sm:px-8 lg:px-20 py-8 lg:py-12 max-w-7xl mx-auto w-full">
        {/* Marketing panel: stacks above on mobile, left column on desktop */}
        <div className="lg:flex-1">
          <AuthMarketingPanel variant={variant} />
        </div>
        {/* Auth widget: full width on mobile, right column on desktop */}
        <div className="flex-shrink-0 w-full lg:w-[480px] lg:min-h-[500px] flex items-center justify-center">
          <Outlet />
        </div>
      </main>
      <AuthFooter />
    </div>
  );
};

export default AuthLayout;
